import { render, staticRenderFns } from "./contactFollow.vue?vue&type=template&id=ff69332e&scoped=true"
import script from "./contactFollow.vue?vue&type=script&lang=js"
export * from "./contactFollow.vue?vue&type=script&lang=js"
import style0 from "./contactFollow.vue?vue&type=style&index=0&id=ff69332e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff69332e",
  null
  
)

export default component.exports